import { HoopsDimensions, HoopsViewer, HoopsViewerLoader } from '@xometry/hoops-viewer';
import Spin from 'antd/es/spin';
import clsx from 'clsx';
import React from 'react';

import s from './ScsViewer.module.less';

interface IProps {
  src: string;
  name: string;
  dimensions?: HoopsDimensions;
  className?: string;
}

const ScsViewer: React.FC<IProps> = ({ src, name, dimensions, className }) => {
  return (
    <HoopsViewerLoader loader={<Spin />}>
      <HoopsViewer
        className={clsx(s.wrapper, className)}
        containerClassName={s.container}
        url={src}
        dimensions={dimensions}
        originalFilename={name}
      />
    </HoopsViewerLoader>
  );
};

export default ScsViewer;
